<template>
    <el-dialog title="查看详情" :visible.sync="visible" width="1100px" :close-on-click-modal="false" :before-close="close">
        <el-scrollbar class="detail-box">
            <div class="detail-box_empty" v-if="noData" style="margin-block: 10px; color: #999">
                该实训暂未作答
            </div>

            <div class="detail-box_answer" v-else>
                <div class="answer-content" v-html="assessmentData.content"></div>

                <div class="answer-file-list">
                    <div class="file-item" v-for="item in assessmentData.file" :key="item.url">
                        <img :src="getFileIcon(item.name)" alt="" />

                        <div class="file-item_info">
                            <div class="info-top">{{ formatFileName(item.name) }}</div>

                            <div class="info-bottom">
                                <div class="info-bottom_size">{{ item.size }}</div>
                                <div class="info-bottom_operate">
                                    <el-button type="text" v-if="getIsPreview(item.name)" @click="previewSource(item)">预览</el-button>
                                    <el-button type="text" @click="downLoadSource(item)">下载</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="detail-box_item detail-box_ai">
                <div class="item-label">AI评分</div>

                <div class="item-value ai-content">
                    <span v-if="assessmentData.ai_evaluate">{{ assessmentData.ai_evaluate }}</span>
                    <span style="color: #999999" v-else>暂无AI评分</span>
                </div>
            </div>

            <div class="detail-box_item detail-box_analysis" v-if="role === 3 && !!analysis.name">
                <div class="item-label">{{ analysis.name }}</div>

                <div class="item-value analysis-content">
                    <div v-html="analysis.value"></div>
                </div>
            </div>

            <div class="detail-box_item detail-box_comment">
                <div class="item-label">教师评语</div>

                <div class="item-value comment-input">
                    <div :class="['comment-text', { 'no-data': !assessmentData.teacher_comment }]" v-if="role === 4 || !isOperate">
                        {{ assessmentData.teacher_comment ? assessmentData.teacher_comment : "暂无教师评语" }}
                    </div>

                    <el-input
                        v-else
                        type="textarea"
                        placeholder="请输入评语"
                        v-model="assessmentData.teacher_comment"
                        :rows="5"
                        resize="none"
                        style="margin-bottom: 10px"
                    ></el-input>
                </div>
            </div>
        </el-scrollbar>

        <span slot="footer" class="dialog-footer" v-if="role !== 4 && isOperate">
            <el-button type="danger" size="medium" @click="backReDoing">打回重做</el-button>
            <el-button type="primary" size="medium" @click="confirmComment">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    name: "SkillAssessmentDetailDialog",
    props: ["visible", "projectId", "studentId", "isOperate", "id", "zhang", "jie", "analysis"],
    data() {
        return {
            assessmentData: {},
            role: Number(localStorage.getItem("role")),
            noData: false,
        };
    },
    watch: {
        visible(newVal, oldVal) {
            if (newVal) {
                this.getAssessmentDetail();
            }
        },
    },
    methods: {
        // 关闭弹框
        close() {
            this.assessmentData = {};

            this.$emit("close");
        },

        getFileIcon(fileName) {
            const iconList = {
                rar: require("../../assets/icons/zip-icon.svg"),
                zip: require("../../assets/icons/zip-icon.svg"),
                doc: require("../../assets/icons/doc-icon.svg"),
                docx: require("../../assets/icons/doc-icon.svg"),
                xls: require("../../assets/icons/xls-icon.svg"),
                xlsx: require("../../assets/icons/xls-icon.svg"),
                pdf: require("../../assets/icons/pdf-icon.svg"),
                jpg: require("../../assets/icons/img-icon.svg"),
                png: require("../../assets/icons/img-icon.svg"),
            };
            const fileExtension = fileName?.slice(((fileName.lastIndexOf(".") - 1) >>> 0) + 2).toLowerCase();
            return iconList[fileExtension] || iconList["jpg"];
        },

        // 是否可以预览。除了压缩包类型都可预览
        getIsPreview(fileName) {
            const fileExtension = fileName?.slice(((fileName.lastIndexOf(".") - 1) >>> 0) + 2).toLowerCase();
            const noPreviewExtensions = ["rar", "zip"];
            let isPreview = true;

            if (noPreviewExtensions.includes(fileExtension)) isPreview = false;

            return isPreview;
        },

        // 定义函数来计算字符的单位长度
        getUnitLength(char) {
            // 中文字符
            if (/[\u4e00-\u9fa5]/.test(char)) {
                return 2;
            }

            // 中文2单位标点
            if (/[，。！？、；：“”‘’（）【】《》——]/.test(char)) {
                return 2;
            }

            // 大写字母占2个单位
            if (/^[A-Z]$/.test(char)) {
                return 2;
            }

            // 英文小写字母和数字，占1个单位
            if (/^[a-z0-9]$/.test(char)) {
                return 1;
            }

            return 1; // 默认单位为 1
        },

        // 格式化文件名
        formatFileName(fileName, nameLength = 34) {
            // 提取文件扩展名
            const extIndex = fileName.lastIndexOf(".");
            const fileExt = fileName.slice(extIndex); // 包括点号的扩展名

            // 去掉扩展名部分，获取文件名
            const nameWithoutExt = fileName.slice(0, extIndex);

            // 计算文件名的单位长度
            let unitCount = 0;
            let i = 0;
            while (i < nameWithoutExt.length && unitCount <= nameLength) {
                unitCount += this.getUnitLength(nameWithoutExt[i]);
                i++;
            }

            // 如果单位长度没有超过38个单位，直接返回原文件名
            if (unitCount <= nameLength) {
                return fileName;
            }

            // 截取文件名的前一部分
            const filePart = {
                lastPart: "",
                lastPartCount: 0,
                firstPart: "",
                firstPartCount: 0,
            };

            for (let index = nameWithoutExt.length - 1; index >= 0; index--) {
                if (filePart.lastPartCount < 4) {
                    filePart.lastPart = nameWithoutExt[index] + filePart.lastPart;
                    filePart.lastPartCount += this.getUnitLength(nameWithoutExt[index]);
                } else {
                    break;
                }
            }

            for (let index = 0; index < nameWithoutExt.length; index++) {
                if (filePart.firstPartCount < nameLength - filePart.lastPartCount - 4) {
                    filePart.firstPart += nameWithoutExt[index];
                    filePart.firstPartCount += this.getUnitLength(nameWithoutExt[index]);
                } else {
                    break;
                }
            }

            // 格式化文件名
            return filePart.firstPart + "...." + filePart.lastPart + fileExt;
        },

        // 获取评价详情
        getAssessmentDetail() {
            const params = {
                // id: this.id,
                course_id: Number(this.$route.query.course_id),
                course_chapter: this.isOperate ? Number(this.$route.query.zhangIndex) : this.zhang,
                course_node: this.isOperate ? Number(this.$route.query.jieIndex) : this.jie,
                project_id: Number(this.projectId),
            };

            if (this.role === 3) {
                params.c_id = Number(localStorage.getItem("class_id"));
                params.s_id = this.studentId;
            }

            this.$shttp.axiosGetBy(this.$api.training_assessment_detail, params, (res) => {
                if (res.code === 200) {
                    this.noData = false;

                    this.assessmentData = res.data;
                } else {
                    this.noData = true;
                }
            });
        },

        // 打回重做
        backReDoing() {
            if (this.assessmentData.status !== 1) {
                this.$message.warning("学生暂未提交");
                return;
            }

            this.$confirm("打回后学生可重新参与实训", "是否确认打回", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                const params = { id: this.id };
                this.$shttp.axiosPost(this.$api.training_back_redoing, params, (res) => {
                    if (res.code === 200) {
                        this.requestSuccess(res.msg);
                    }
                });
            });
        },

        // 提交评语
        confirmComment() {
            if (this.assessmentData.status !== 1) {
                this.$message.warning("学生暂未提交");
                return;
            }

            const params = {
                id: this.id,
                comment: this.assessmentData.teacher_comment,
            };
            this.$shttp.axiosPost(this.$api.training_score, params, (res) => {
                if (res.code === 200) {
                    this.requestSuccess(res.msg);
                }
            });
        },

        requestSuccess(msg) {
            this.$message.success(msg);
            this.$emit("update");
            this.close();
        },

        // 下载文件
        downLoadSource(file) {
            const link = document.createElement("a");
            link.href = file.url;
            link.download = file.name;
            link.click();
        },

        // 预览文件
        previewSource(file) {
            const fileExtension = file.url?.slice(((file.url.lastIndexOf(".") - 1) >>> 0) + 2).toLowerCase();

            if (["jpg", "png"].includes(fileExtension)) {
                this.$emit("preview", file.url);
            } else {
                const routeHref = this.$router.resolve({
                    path: "/training/preview",
                    query: {
                        src: file.url,
                    },
                }).href;

                window.open(routeHref, "__blank");
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.el-button.el-button--danger {
    background-color: #ff1414;
}

.el-button.el-button--primary {
    background-color: #006eff;
}

.detail-box {
    ::v-deep .el-scrollbar__wrap {
        width: calc(100% - 40px);
        max-height: calc(90vh - 55px - 66px - 40px);
        // padding: 20px 20px;
        box-sizing: border-box;
        margin: 20px !important;

        &::-webkit-scrollbar {
            display: none;
        }
    }

    &_answer {
        .answer-file-list {
            width: 100%;
            display: flex;
            gap: 10px;
            flex-wrap: wrap;

            .file-item {
                width: calc((100% - 20px) / 3);
                height: 72px;
                border-radius: 4px;
                background-color: #f6f6f6;
                box-sizing: border-box;
                padding: 16px;
                display: flex;
                gap: 10px;

                img {
                    width: 40px;
                    height: 40px;
                    object-fit: cover;
                }

                &_info {
                    width: calc(100% - 50px);

                    .info-top {
                        white-space: nowrap;
                    }

                    .info-bottom {
                        margin-top: 6px;
                        display: flex;
                        justify-content: space-between;
                        align-content: center;

                        &_size {
                            color: #999999;
                        }

                        .el-button {
                            padding-block: 0;
                        }
                    }
                }
            }
        }
    }

    &_item {
        margin-top: 30px;

        .item-label {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 500;
            font-size: 16px;
            color: #000000;
            line-height: 21px;
        }

        .item-value {
            margin-top: 10px;
        }
    }

    &_ai {
        .ai-content {
            padding: 20px;
            background-color: #fcfcfc;
        }
    }

    &_analysis {
        .analysis-content {
            padding: 10px;
            background-color: #fcfcfc;
        }
    }

    &_comment {
        .comment-input {
            .comment-text {
                padding: 20px;
                background-color: #fcfcfc;

                &.no-data {
                    color: #999999;
                }
            }
        }
    }
}
</style>
